export default "__VITE_ASSET__0e7f3d65__"